import React, { FC } from 'react'

import { WrappedFieldProps } from 'redux-form'

import ListBox from '~/components/shared/ListBox/ListBox'
import { ListBoxProps } from '~/components/shared/ListBox/types'

type Props = {
  onChange?: (v: any) => void
}

const ListBoxField: FC<WrappedFieldProps & ListBoxProps & Props> = ({
  input: { onChange, value, name },
  onChange: onCustomChange,
  optionSettings,
  multiple,
  ...rest
}) => {
  const handleChange = (value) => {
    if (onCustomChange) {
      onCustomChange(value)
    }
    onChange(value)
  }

  return (
    <ListBox
      onChange={handleChange}
      optionSettings={optionSettings}
      multiple={multiple}
      {...rest}
      value={value}
      name={name}
    />
  )
}

export default ListBoxField
